import { Component, OnInit, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BlogPostService } from './blog-post.service';
import { Observable } from 'rxjs';
import { TokenStorage } from './token.storage';
import { ApiService } from './api.service';
import { Router } from '@angular/router';
// import { AuthService } from './services/auth.service';
import * as $ from 'jquery';



export const APP_ID = environment.appId;
export const PROPERTY_ID = environment.propertyId;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  title = 'hotelWebsite';
  blogPost: any[] = [];
  blogPosts$: Observable<any> | undefined;
  property: any;
  businessUser: any;
  googleReviews: any;
  chunkedReviews: any;
  viewportScroller: any;
  dynamicText: any;
  dynamicPropertyId: any;
  dynamicCity: any;
  dynamicStreetName: any;
  dynamicStreetNumber: any;
  dynamicLocality: any;
  dynamicCountryName: any;
  propertyusername: string;
  isMobileView: any;
  googleReviewsOptional:any;

  carouselItems = [
    { imgSrc: 'assets/images/Shree Mangueshi Temple.webp', title: 'Shree Mangueshi Temple' },
    { imgSrc: 'assets/images/Shree Shantadurga Temple.webp', title: 'Shree Shantadurga Temple' },
    { imgSrc: 'assets/images/Palolem Beach.webp', title: 'Palolem Beach' },
    { imgSrc: 'assets/images/Deltin Royale.webp', title: 'Deltin Royale' },
    { imgSrc: 'assets/images/Agonda.webp', title: 'Agonda' }
  ];

  constructor(
    public router: Router,
    private contentfulService: BlogPostService,
    private tokenStorage: TokenStorage,
    private apiService: ApiService,
    private renderer: Renderer2,
    private cdrf: ChangeDetectorRef,
    // private authService: AuthService
  ) { }

  ngOnInit(): void {
    // Token initialization from persistent storage
    const token = localStorage.getItem('token');
    // if (token) {
    //   this.authService.setToken(token);
    // }

    // Setup default reviews and get blog entries
    this.googleReviews = [
      { reviewerName: 'Abhishek Garg', reviewText: "Rooms are small, staff is not responsive, AC sound was irritating but the location is best, if you have early morning flight then you can prefer this as it’s affordable and walkable from the Bhuvneshwar airport.", rating: "4" },
      { reviewerName: 'Nikhila M', reviewText: "I recently stayed at Green Star Inn and had a pleasant experience. The staff was friendly, the room was clean and comfortable, and the amenities were decent. A good value for a budget stay! And we enjoyed the stayand we recommend it for sure .", rating: "5" },
      { reviewerName: 'Sidharth Swain', reviewText: "Rooms are good and proper hygiene is maintained but staff behaviour is not upto the mark. Food items are good in taste.", rating: "5" },
      { reviewerName: 'Snehalata P', reviewText: "Overally experience was so good,and all the staff are specially jharana madam(assistant manager) is so friendly and co supportive. Restaurant taste is good but need some improvement.clean and hygiene rooms and corridor. Parking facility available and that's safe.", rating: "5" },
      { reviewerName: 'Manish Kumar', reviewText: "Room is well decorated, bathroom is old and very small, room is good for Couple not for Family.Too much noise coming from next room. No any aminities provided like Bathing kit, Dental kit, for complimentary water i asked 2time then they provided.Complimentary Breakfast was not provided as they told kitchen is closed due to Deewaali Holiday.", rating: "4" },
      { reviewerName: 'The D', reviewText: "Very good staff..... excellent service and asm food .....staff behaviour so humble & instant solution any problem...the hotel room is a very clean...my experience is a to good|This hostel Biju Pattnayak airport and easily accessible off from rode.", rating: "5" },
      { reviewerName: 'Dwipin T Manohar', reviewText: "Had stayed in The Green Star Inn during my official visit to Bhubaneshwar last week. Had stayed there for 3 days and it had been a pleasant experience. The place is located almost with in a km from the Biju Patnaik Airport and is easily accessible even though its a lil off from the main road. The rooms were spacious and very clean. The staff were courteous and professional. The food was tasty and nominally priced and the portions were sufficient to kill one's hunger. The only downside was that there is no power backup and as it rained for 2 days, there had been frequent outages at night. Overall the stay experience was great 👏👏👌👍", rating: "5" },
      { reviewerName: 'Abhisek Purohit', reviewText: "The people and the rooms are good… though the room i got was bit on the smaller side. The rooms were all well kept. But finding the place would be an issue. But if taken one will not regret it.", rating: "4" },
      { reviewerName: 'Rishi Sharma', reviewText: "Very nice and lovely assistance by Chandan and sandhya Thanks a lot", rating: "5" },
      { reviewerName: 'Anjani Patnaik', reviewText: "Had a great experience 👍🏼.. Sandhya was awesome..she really takes care of u so well with a personal touch..very sweet & charming..All the Best to her & the hotel 👍🏼!", rating: "5" },
      { reviewerName: 'Tanmay Ranjan Behera', reviewText: "The rooms in the ground floor are old and having mosquitoes problem. The rooms are of decent size. The first floor rooms are new and better. Regarding the food service, they are very late. I have ordered for a cup of tea at 8 Am and got the tea at 9:30AM. We have tried there lunch also, the food was really good but they will take sure 1hr to send it to your room. So be aware of that fact. The location is good. One can easily come here from the Airport road by a taxi or autorickshaw. If you want piping hot breakfast/evening snacks better you walk 600m and go to New Airport Road. There is an Omfed store also.", rating: "4" },
      { reviewerName: 'Chitrabhanu Mohanta', reviewText: "One of the best budget hotels one can be in.Tidy rooms. Clean and spacious beds. Bathroom was well maintained and offers all the desired amenities including a geyser. Inhouse Kitchen assures freshly prepared delicious food. The food is affordable and the staff is very supportive.", rating: "5" }
    ];

    this.googleReviewsOptional = [
      { reviewerName: 'JOHN BAHADUR Nayak', reviewText: "I am proud to be a part of the sky lantern , this is the part of green star inn premium hotel , Rooms are perfectly design and pocket friendly , Service is too good , Location also easy to reach , The best part is food 😋 Delicious food with minimal price.", rating: "5" },
      { reviewerName: 'Panda Sarojini', reviewText: "This hotel is a very clean and clear. Food is very amazing test. And my experience is very memorable. Hotel staff is very careful and good behaviour.", rating: "5" },
      { reviewerName: 'soumyajeet biswal', reviewText: "Good Rooms. Food is also good.Polite staffs and helpful. Had a 5 day stay here. Approaching road is te only problem. Else no issues with hotel.", rating: "5" },
      { reviewerName: 'pabitra panda', reviewText: "Really it was a good experience. Hotel was neat and clean. Service was too good. Excellent food provide by the hotel. Staffs are good well behaved.", rating: "5" },
      { reviewerName: 'laxmi timberggn', reviewText: "Everything was very satisfing and very kind of staff…. We enjoyed the stay", rating: "5" },
      { reviewerName: 'Lopa Tripathy', reviewText: "Greenstar inn puri is best in good price room cleaning is good and satisfying jst bit far from beach bt walkable staff are good bt not always available", rating: "4" },
      { reviewerName: 'Mitali Sharma', reviewText: "excellent service, and very friendly staff. comfortable.", rating: "5" },
      { reviewerName: 'sukant mohanty', reviewText: "Best Hotel in bhubaneswar and quality and food very good.", rating: "5" },
      { reviewerName: 'SUNIL NAYAK', reviewText: "Very good hotel with beautiful interior . Best service", rating: "5" },
      { reviewerName: 'sumant samantray', reviewText: "A good and decent hotel to stay. Veg food is nice.", rating: "4" },
      { reviewerName: 'Madhur Sharma', reviewText: "Best hotel in bhubaneswar and good service for all things in hotelGood Rooms. Food is also good.Polite staffs and helpful. Had a 5 day stay here. Approaching road is te only problem. Else no issues with hotel.", rating: "5" },
      { reviewerName: 'Anshul Lakhera', reviewText: "Hotels are absolutely fantastic! They provide such a comfortable and luxurious experience for guests. The attention to detail and impeccable service really make them stand out. Plus, the amenities and beautiful decor create a wonderful atmosphere.", rating: "5" }
    ];
    this.blogPosts$ = this.contentfulService.getAllEntries();

    // Retrieve user property details and set theme colors
    this.businessUser = this.tokenStorage.getProperty();
    this.getProperty();
    this.changeTheme(
      this.businessUser.primaryColor,
      this.businessUser.secondaryColor,
      this.businessUser.tertiaryColor
    );

    // Add event listener for the chatbot payload
    window.addEventListener('df-request-sent', (event) => {
      this.propertyusername = this.businessUser.name;
      const chatbotElement = document.getElementById('chatbot');
      if (chatbotElement) {
        chatbotElement.setAttribute('chat-title', this.propertyusername);
        chatbotElement.setAttribute('chat-title-icon', this.businessUser.logoUrl);
      }
      const propertyId = this.businessUser.id;
      const propertyName = this.businessUser.name;
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const hours = String(currentDate.getHours()).padStart(2, '0');
      const minutes = String(currentDate.getMinutes()).padStart(2, '0');
      const seconds = String(currentDate.getSeconds()).padStart(2, '0');
      const currentTimeString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      const dataToSend = {
        propertyId: propertyId,
        propertyName: propertyName,
        currentDate: currentTimeString,
      };
      fetch('https://chatbot.api.thehotelmate.co/api/website/receivePayload', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      })
        .then(response => response.json())
        .catch(error => console.error('Error:', error));
    });
  }


  chunkReviews(): void {
    this.chunkedReviews = [];
    const chunkSize = 2;
    for (let i = 0; i < this.googleReviews.length; i += chunkSize) {
      this.chunkedReviews.push(this.googleReviews.slice(i, i + chunkSize));
    }
  }

  getWhatsappShareUrl(): string {
    const baseUrl = 'https://api.whatsapp.com/send';
    const phoneNumber = this.businessUser?.whatsApp; // Assuming whatsApp is part of businessUser

    // Assign dynamic properties
    this.dynamicText = this.businessUser?.name;
    this.dynamicPropertyId = this.businessUser?.id;
    this.dynamicCity = this.businessUser?.address?.city;
    this.dynamicStreetName = this.businessUser?.address?.streetName;
    this.dynamicStreetNumber = this.businessUser?.address?.streetNumber;
    this.dynamicLocality = this.businessUser?.address?.locality;
    this.dynamicCountryName = this.businessUser?.address?.country;

    // Construct the message for WhatsApp
    const message = `*This is an Enquiry from :*Website: ${this.dynamicText || ''}`;
    return `${baseUrl}?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
  }

  getProperty(): void {
    this.apiService.getPropertyDetailsByPropertyId(PROPERTY_ID).subscribe(
      (response) => {
        this.property = response.body;
        this.businessUser = response.body;
        this.tokenStorage.saveProperty(this.property);
        this.cdrf.detectChanges();
        this.initializeSlideItems();
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          console.error('Error fetching property details:', error.message);
        }
      }
    );
  }
  

  changeTheme(primary: string, secondary: string, tertiary: string): void {
    document.documentElement.style.setProperty('--primary', primary);
    document.documentElement.style.setProperty('--secondary', secondary);
    document.documentElement.style.setProperty('--tertiary', tertiary);
    document.documentElement.style.setProperty('--button-primary', tertiary);
    document.documentElement.style.setProperty(
      '--primary-gradient',
      'linear-gradient( 180deg, ' + tertiary + ', ' + secondary + ')'
    );
    document.documentElement.style.setProperty(
      '--secondary-gradient',
      'linear-gradient( 312deg, ' + primary + ', ' + secondary + ')'
    );
    document.documentElement.style.setProperty(
      '--secondary-one-gradient',
      'linear-gradient( 180deg, ' + primary + ', ' + secondary + ')'
    );
    document.documentElement.style.setProperty(
      '--third-gradient',
      'linear-gradient( 180deg, ' + primary + ', ' + secondary + ')'
    );
  }

  expandText(event: Event): void {
    const target = event.target as HTMLElement;
    const parent = target.closest('.testimonial');
    if (!parent) return;
    const textContainer = parent.querySelector('.text-truncated');
    if (!textContainer) return;
    const fullText = textContainer.getAttribute('data-full-text');
    if (fullText) {
      textContainer.textContent = fullText;
      target.style.display = 'none';
    }
  }

  navigate(): void {
    const seoFriendlyName = this.tokenStorage.getProperty()?.seoFriendlyName || '';
    window.open(`https://bookone.io/${seoFriendlyName}?BookingEngine=true`, '_blank');
  }

  initializeSlideItems(): void {
    // Add implementation for initializing slide items
  }

  scrollToSection(section: string): void {
    this.router.navigate([], { fragment: section }).then(() => {
      if (this.viewportScroller) {
        this.viewportScroller.scrollToAnchor(section);
      }
    });
  }
}

export const PARENTS_ORGANIZATION_ID = environment.parentOrganisationId;

export const API_URL_NZ = environment.nzAPIUrl;
export const API_URL_IN = environment.inAPIUrl;
export const API_URL_PROMOTION = environment.apiUrlPromotion;
export const API_URL_ADDRESS = environment.apiUrlAddress;
// export const APP_ID = environment.appId;
export const EMAIL_Expression: RegExp = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
export const dashboardUrl = environment.dashboardUrl;
export const ANDROID_APP_URL = environment.androidAppUrl;
export const IOS_APP_URL = environment.iosAppUrl;
export const SMS_NUMBER = '+1 956 903 2629';
